import { InputAdornment, TextField } from "@mui/material";

import type { FlightFormLocation } from "@/types/types";
import { getCityName } from "@/utils/locations";

type LocationPickerProps = {
  value: FlightFormLocation | null;
  label: React.ReactNode;
  errorMessage?: string;
  startIcon?: React.ReactNode;
  shouldShowCode?: boolean;
  onPickerOpen: () => void;
};

export function LocationPicker({
  label,
  value,
  startIcon,
  errorMessage,
  shouldShowCode = true,
  onPickerOpen,
}: LocationPickerProps) {
  return (
    <TextField
      fullWidth
      onClick={onPickerOpen}
      slotProps={{
        input: {
          startAdornment: startIcon && (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          ),
        },
      }}
      sx={{
        input: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          userSelect: "none",
        },
      }}
      value={`${getCityName(value)}${shouldShowCode && value?.code ? ` (${value.code})` : ""}`}
      error={!!errorMessage}
      helperText={errorMessage}
      label={label}
    />
  );
}
